// extracted by mini-css-extract-plugin
export var button = "_cf-7";
export var buttonRow = "_cf-6";
export var fadeIn = "_cf-1";
export var gradient = "_cf-0";
export var panel = "_cf-2";
export var panelIn = "_cf-3";
export var subtitle = "_cf-5";
export var title = "_cf-4";